/**
 * a function to validate the documents uploaded
 * @param docsToUpload
 * @param responsesDocuments
 * @returns
 */
export const validateDocumentsUpload = (
  docsToUpload: Record<string, number>,
  responsesDocuments: Record<string, any[]>
): string => {
  const errors: string[] = [];
  let isFirstError = true;

  // Add 'id' to docsToUpload if it's not already present
  if (!("id" in docsToUpload)) {
    docsToUpload["id"] = 1;
  }

  for (const [docType, requiredCount] of Object.entries(docsToUpload)) {
    const uploadedDocs = responsesDocuments?.[docType] ?? [];
    const uploadedCount = uploadedDocs.length;
    if (uploadedCount < requiredCount) {
      if (isFirstError) {
        errors.push(
          `Please upload the following documents: ${
            requiredCount - uploadedCount
          } ${docType}`
        );
        isFirstError = false;
      } else {
        errors.push(`${requiredCount} ${docType} document(s)`);
      }
    }
  }

  return errors.join(", "); // Return all errors as a single string, or an empty string if all validations passed
};
